/*
 * Minimal replacement for the subset of lodash used by wpbingo.js
 * (assignIn, compact, escape, filter, find, findIndex, isEqual, isFunction, isUndefined, map).
 * Replaces the full 73 KB lodash build. Keep the semantics of the call sites in wpbingo.js:
 * predicates are always functions and collections are arrays or array-likes (jQuery objects).
 */
(function (root) {
  if (root._ && root._.VERSION) return; // a full lodash is already on the page

  function toArray(collection) {
    if (collection == null) return [];
    if (Array.isArray(collection)) return collection;
    if (typeof collection.length === 'number') return Array.prototype.slice.call(collection);
    return Object.keys(collection).map(function (key) { return collection[key]; });
  }

  var htmlEscapes = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

  function isEqual(a, b) {
    if (a === b) return true;
    if (a !== a && b !== b) return true; // NaN
    if (a && b && typeof a === 'object' && typeof b === 'object') {
      var keysA = Object.keys(a);
      var keysB = Object.keys(b);
      if (keysA.length !== keysB.length || Array.isArray(a) !== Array.isArray(b)) return false;
      for (var i = 0; i < keysA.length; i++) {
        if (!Object.prototype.hasOwnProperty.call(b, keysA[i]) || !isEqual(a[keysA[i]], b[keysA[i]])) return false;
      }
      return true;
    }
    return false;
  }

  root._ = {
    assignIn: function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        if (source == null) continue;
        for (var key in source) target[key] = source[key]; // own + inherited, like lodash assignIn
      }
      return target;
    },
    compact: function (array) { return toArray(array).filter(Boolean); },
    escape: function (string) {
      return string == null ? '' : String(string).replace(/[&<>"']/g, function (chr) { return htmlEscapes[chr]; });
    },
    filter: function (collection, predicate) { return toArray(collection).filter(predicate); },
    find: function (collection, predicate) { return toArray(collection).find(predicate); },
    findIndex: function (array, predicate) { return toArray(array).findIndex(predicate); },
    isEqual: isEqual,
    isFunction: function (value) { return typeof value === 'function'; },
    isUndefined: function (value) { return value === undefined; },
    map: function (collection, iteratee) { return toArray(collection).map(iteratee); }
  };
})(window);
